import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    // Close sidebar on mobile by default
    if (window.innerWidth < 1024) {
      this.close()
    } else {
      this.open()
    }

    // Handle window resize
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
  }

  handleResize() {
    // Close sidebar when switching to mobile
    if (window.innerWidth < 1024) {
      this.close()
    }
  }

  toggle() {
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.classList.remove("-translate-x-full")
    this.sidebarTarget.classList.add("translate-x-0")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
    document.body.style.overflow = "hidden"
  }

  close() {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.classList.remove("translate-x-0")
    this.sidebarTarget.classList.add("-translate-x-full")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
    document.body.style.overflow = ""
  }

  isOpen() {
    if (!this.hasSidebarTarget) return false
    return !this.sidebarTarget.classList.contains("-translate-x-full")
  }
}
